<template>
    <div class="main-announcement">
        <div class="works-content">
            <div class="works-header">
                <div class="works-title">最新作品公示</div>
            </div>
            <div class="works-list">
                <ul>
                    <li class="work-item" v-for="item in workList" @click="showModal(item)">
                        <div class="work-info">
                            <div class="thumbnail">
                                <img src="@/assets/images/work-cert.jpeg" width="120px"/>
                            </div>
                            <div class="work-desc">
                                <p class="desc-title">
                                    <span>{{item.worksName}}</span>
                                </p>
                                <div class="desc-line"></div>
                                <div class="desc-item" >
                                    <div class="item-name">证书编号：</div>
                                    <div class="item-value">{{item.copyrightRegisterAuthCertNo}}</div>
                                </div>
                               
                                <div class="desc-item">
                                    <div class="item-name">著作权人：</div>
                                    <div class="item-value">{{item.owners}}</div>
                                </div>
                                <div class="desc-item">
                                    <div class="item-name">作品类型：</div>
                                    <div class="item-value">{{item.worksType}}</div>
                                </div>
                                <div class="desc-item">
                                    <div class="item-name">公开发表时间：</div>
                                    <div class="item-value">{{item.createTime}}</div>
                                </div>
                                <div class="desc-item">
                                    <div class="item-name">证明效力状态：</div>
                                    <div class="item-value">公示中</div>
                                </div>
                                <div class="desc-item">
                                    <div class="item-name">作品说明：</div>
                                    <div class="item-value">{{item.worksContent}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="work-info-title">
                            <p class="work-name" title="123456">{{item.worksName}}</p>
                            <p class="announce-time">
                                <span>
                                    <i class="el-icon-time"></i>
                                    <span>{{formatDate(item.createTime)}}</span>
                                </span>
                                <span>开始公示</span>
                            </p>
                            <p class="announce-time">
                                <span>
                                    <i class="el-icon-time"></i>
                                    <span>{{pushBackDate(item.createTime)}}</span>
                                </span>
                                <span>结束公示</span>
                            </p>
                        </div>
                    </li>
                </ul>
                <div class="announcemen-page">
                    <el-pagination layout="prev, pager, next,sizes,jumper":total="pageInfo.total" 
                    :hide-on-single-page="true"  :page-sizes="[4,8,12,16]" :page-size="pageInfo.pageSize"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange">

                    </el-pagination>
                </div>
            </div>
        </div>
        <WorkInfo ref="workModal"/>
    </div>
</template>
<script>
    import WorkInfo from "./modal/WorkInfo.vue"
    import { getWorkList } from '@/api/business'
    import dayjs from "dayjs";
    export default {
        data () {
            return {
                workList:[],
                pageInfo:{
                    pages:2,
                    current:1,
                    total:0,
                    pageSize:8
                },
            }
        },
        components:{
            WorkInfo
        },
        mounted() {
            this.init();
        },
        methods: {
            init(){
                getWorkList({pageNo:this.pageInfo.current,pageSize:this.pageInfo.pageSize}).then(res=>{
                    this.workList = res.result.records
                    this.pageInfo.total = res.result.total;
                })
            },
            handleSizeChange(val) {
                this.pageInfo.pageSize = val;
                this.init();
            },
            handleCurrentChange(val) {
                this.pageInfo.current = val;
                this.init();
            },
            showModal(item){
                this.$refs.workModal.showDialog(item);
            },
            pushBackDate(dateStr){
                if(dateStr){
                    const date = dayjs(dateStr);
                    const nextMonth = date.add(60, 'day');
                    return nextMonth.format('YYYY-MM-DD HH:mm');
                }
            },
            formatDate(dateStr){
                if(dateStr){
                    const date = dayjs(dateStr);
                    return date.format('YYYY-MM-DD HH:mm');
                }
            }
        }
    }
</script>

<style lang="less" scoped>

.main-announcement{
    .announcemen-page{
        padding: 30px 0px;
        text-align: right;
    } 
    margin-top: 68px;
    text-align: left;
    .works-content{
        width: 1200px;
        margin: 0 auto;
        padding-top: 50px;
        .works-header{
            display: flex;
            height: 30px;
            .works-title{
                font-size: 16px;
                line-height: 30px;
                padding: 0 10px;
                border-radius: 4px;
                cursor: pointer;
                user-select: none;
                color: #fff;
                background-color: #206BD1 !important;
            }
        }
        .works-list{
            padding-top: 20px;
            box-sizing: border-box;
            ul{
                display: flex;
                flex-wrap: wrap;
            }
            .work-item{
                width: 285px;
                height: 265px;
                // border: 1px solid #000;
                box-sizing: border-box;
                border-radius: 4px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                user-select: none;
                cursor: pointer;
                .work-info{
                    height: 160px;
                    width: 100%;
                    display: flex;
                    background-image: url("@/assets/images/announcement-bg.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    .thumbnail{ 
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex: 1;
                        border: 1px solid #999;
                        height: 120px;
                        margin-top: 20px;
                    }
                    .work-desc{
                        height: 100%;
                        width: 160px;
                        position: relative;
                        font-size: 8px;
                        padding: 20px 5px;
                        box-sizing: border-box;
                        .desc-title{
                            font-size: 8px;
                            font-weight: 600;
                            width: 150px;
                            white-space: nowrap; /* 确保文本在一行内显示 */
                            overflow: hidden; /* 隐藏超出容器的内容 */
                            text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */ 
                           
                        }
                        .desc-line{
                            width: 100%;
                            position: relative;
                            height: 10px;
                        }
                        .desc-line::after{
                            content: "";
                            height: 1px;
                            width: 150px;
                            position: absolute;
                            left: 0;
                            top: 5px;
                            background-color: #666;
                        }
                        .desc-item{
                            height: 18px;
                            
                            display: flex;
                            
                            align-items: center;

                            .item-name{
                                width: 60px;
                            }
                            .item-value{
                                width: 90px;
                                white-space: nowrap; /* 确保文本在一行内显示 */
                                overflow: hidden; /* 隐藏超出容器的内容 */
                                text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */ 
                            }
                        }


                    }
                }
                .work-info-title{
                    padding: 0px 15px;
                    .work-name{
                        font-size: 16px;
                        font-weight: 600;
                        width: 90%;
                        white-space: nowrap; /* 确保文本在一行内显示 */
                        overflow: hidden; /* 隐藏超出容器的内容 */
                        text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
                        line-height: 30px;
                    }
                    .announce-time{
                        font-size: 14px;
                        color: #666;
                        line-height: 25px;
                        display: flex;
                        justify-content: space-between; 
                    }
                }
            }
            .work-item:nth-child(4n + 2),.work-item:nth-child(4n + 3),.work-item:nth-child(4n + 4){
                margin-left: 20px;
            }
            .work-item:nth-child(n + 5){
                margin-top: 20px;
            }
        }
        
    }
}
</style>